// extracted by mini-css-extract-plugin
export default {"block":"Ratings_block__RHqdn"};